import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Distributor } from '@wsphere/distributors/domain';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-distributor-account-page',
  templateUrl: './account.page.html',
  standalone: false,
})
export class DistributorAccountPage {
  @Input() distributor?: Distributor.Model | null;

  maskSensitiveValue(value?: string | null) {
    if (!value) return '';
    return `•••• ${value.slice(-4)}`;
  }
}
